import { useMsal } from '@azure/msal-react';
import { trackCustomEvent } from '@/lib/appInsights';
import { sendMessageToSentry } from '@/lib/sentry';
import { TrackingCustomEvents } from '@/constants/constants';

export const useAuthActions = () => {
  const { instance } = useMsal();

  // TODO: Review all login redirect paths.
  const handleLogin = () => {
    sendMessageToSentry('Event: Nav Login button clicked');
    trackCustomEvent(TrackingCustomEvents.click.navbar.login);

    // Check if current path is an article
    const currentPath = location.pathname;
    const isArticlePath = currentPath.startsWith('/article/');
    const redirectStartPage = isArticlePath ? currentPath : '/home';

    instance.loginRedirect({
      redirectStartPage,
      scopes: [],
    });
  };

  const handleLogout = () => {
    sendMessageToSentry('Event: Nav Logout button clicked');
    trackCustomEvent(TrackingCustomEvents.click.navbar.logout);
    instance.logoutRedirect({
      postLogoutRedirectUri: '/',
    });
  };

  return { handleLogin, handleLogout };
};
